import { AppointmentReportBySpecialty } from '~/domain/usecases/report/remote';
import {
  InvalidCredentialsError,
  UnexpectedError,
  BadRequestError,
} from '~/domain/errors';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import '~/infra/global/variables';

export class RemoteAppointmentReportBySpecialty
  implements AppointmentReportBySpecialty
{
  private readonly url: string;

  private readonly httpClient: HttpClient<AppointmentReportBySpecialty.Model>;

  constructor(
    url: string,
    httClient: HttpClient<AppointmentReportBySpecialty.Model>,
  ) {
    this.url = url;
    this.httpClient = httClient;
  }

  get = async (
    params: AppointmentReportBySpecialty.Params,
  ): Promise<AppointmentReportBySpecialty.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'post',
      body: params,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  };
}
